import React, { useState } from 'react';

import { httpClient } from '../../api/httpClient';
import { useExportColumnsSelection } from '../../hooks/useExportColumnsSelection';
import { ExportColumnsButton } from './ExportDialog/ExportColumnsButton';
import { ExportModalBase } from "./ExportDialog/ExportModalBase";
import { ExportTriggerButton } from './ExportDialog/ExportTriggerButton';
import { useSimpleModal } from './useSimpleModal';

const ExportModal = ({ onModalClose, columnsChoices, columns, endpoint, filters, sort }) => {
	const { columnsSelected, setColumnsSelected, excludedColumns } = useExportColumnsSelection(columns);

	const filtersData = React.useMemo(() => ({
		...filters,
		excluded_columns: excludedColumns,
	}), [filters, excludedColumns]);

	return (
		<ExportModalBase filters={filtersData} sort={sort} endpoint={endpoint} onModalClose={onModalClose}
			titleButtons={<ExportColumnsButton choices={columnsChoices} value={columnsSelected} onChange={setColumnsSelected} />}
		/>
	);
};

export const DataExport = ({filters, sort, data}) => {
	const exportModal = useSimpleModal();
	const [ isLoading, setIsLoading ] = useState(false);
	const [ columns, setColumns ] = React.useState([]);
	const [ columnsChoices, setColumnsChoices ] = React.useState([]);
	const onOpen = () => {
		setIsLoading(true);
		
		httpClient(`${data}-export-header`)
			.then((promColumnsRes) => {		
				if (promColumnsRes.json) {
					const _columnsChoices = promColumnsRes.json.map(x => ({id: x[0], name: x[1]}));			
					const _columnsSelected = promColumnsRes.json.map(x => x[0]);
					setColumnsChoices(_columnsChoices);
					setColumns(_columnsSelected);				
				}			
				exportModal.handleOpen();	
			})
			.catch(err => {
                console.error(err);                
            })
			.finally(() => {
				setIsLoading(false);
			});
	};

	return (
		<React.Fragment>
			<ExportTriggerButton label="osfc.buttons.export_search" isLoading={isLoading} onClick={onOpen} />
			{exportModal.opened && <ExportModal endpoint={data} onModalClose={exportModal.handleClose} columns={columns} columnsChoices={columnsChoices} filters={filters} sort={sort} />}
		</React.Fragment>
	);
};
